import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Col, Row, Card, Accordion, Button } from 'react-bootstrap';
import prof from '../../../../assets/images/prof.svg';
import './JobApplicants.css';
import { MdArrowDropDown } from 'react-icons/md';
import { ReqGet, ReqPost } from '../../../../config/Requests';
import {
	Container,
	Tab,
	Nav,
	Modal,
	Form,
	FormControl,
	InputGroup,
} from 'react-bootstrap';
import { Stack, Typography } from '@mui/material';
function NewApplicants(props) {
	let url = window.location.href;

	const [applicantList, setApplicantList] = useState([]);
	const id = url.split('/').reverse()[1];
	const navigate = useNavigate();
	const [tagsFormatedData, setTagFormatedData] = useState([]);

	const viewProfileHandler = item => {
		navigate(`/job/${id}/applicants/view-profile`, {
			state: { applicantList: item },
		});
	};
	useEffect(() => {
		ReqGet(`job/${id}/applicants`)
			.then(res => {
				setApplicantList(res.data);
				const parents = res.data[0].tags.map(tag => {
					return {
						parent: tag.parent,
						child: [],
					};
				});

				const uniqueArray = Array.from(
					new Set(parents.map(JSON.stringify))
				).map(JSON.parse);

				for (let par = 0; par < uniqueArray.length; par++) {
					for (let child of res.data[0].tags) {
						if (uniqueArray[par].parent.id === child.parent.id) {
							// delete child.parent;
							uniqueArray[par].child = [...uniqueArray[par]?.child, child];
						}
					}
				}
				setTagFormatedData(uniqueArray);
			})

			.catch(err => {
				console.log(err.response);
			});
	}, []);

	const declineApplicantHandler = (memberId, jobId) => {
		// return
		ReqPost(`decline-member/job/${jobId}`, { members: memberId })
			.then(res => {
				console.log(res.data);
				props.applyApplicantHandler(jobId);
				ReqGet(`job/${id}/applicants`)
					.then(res => {
						setApplicantList(res.data);
						console.log(res.data);
					})
					.catch(err => {
						console.log(err.response);
					});
			})
			.catch(err => {
				console.log(err.message);
			});
	};
	return (
		<div style={{ height: 'auto' }}>
			<h6 className='title mt-4 mb-4'>New Applicants</h6>
			<Row className='cards-container'>
				{applicantList.map((item, i) => {
					return (
						<Accordion key={i}>
							<Card className='accordion-card'>
								<Accordion.Item style={{ width: '100%' }} eventKey='0'>
									<Accordion.Header
										as={Button}
										variant='link'
										eventKey='0'
										style={{ width: '100%' }}
									>
										<Stack gap={2} direction={'row'} spacing={2}>
											{`ID: ${item?.id}  `}
											<Typography>{item?.fullname}</Typography>
										</Stack>
									</Accordion.Header>
									<Accordion.Body className='p-0'>
										<Card className='applicant-card' style={{ border: 'none' }}>
											<Card.Body>
												{/*  */}
												<Row className='row' style={{ width: '150%' }}>
													<img
														className='profile-img'
														src={
															item?.profile_image ? item.profile_image : prof
														}
														alt='profile'
													/>
													<Col>
														<h6 className='name'> {item.fullname} </h6>
														<h6 className='name'>ID: {item.id} </h6>
													</Col>
													<button
														className='btn-download-resume p-2'
														onClick={() => viewProfileHandler(item)}
													>
														View {item.fullname}'s Profile
													</button>
													<button
														className='btn-short-list fw-bold'
														onClick={() =>
															props.shortlisted(item.id, item.pivot.job_id)
														}
													>
														Short-list
													</button>
													<button
														className='btn-decline fw-bold'
														onClick={() =>
															declineApplicantHandler(
																item.id,
																item.pivot.job_id
															)
														}
													>
														Decline
													</button>
												</Row>
												<Form
													style={{
														border: '1px solid',
														marginTop: '12px',
														width: '149%',
													}}
												>
													<Row>
														<Col sm={12}>
															<div
																className={'top-actions bg-label'}
																style={{
																	width: '101.39%',
																	borderBottom: ' 1px solid',
																	// marginLeft: '-15px',
																	marginLeft: '-12px',
																}}
															>
																<Row>
																	<Col sm={12}>
																		<div className={'top-actions bg-label'}>
																			<h4
																				className={
																					'heading text-orange font-weight-bold p-2 ml-1 rounded'
																				}
																			>
																				Member Profile
																			</h4>
																		</div>
																	</Col>
																</Row>
															</div>
														</Col>
													</Row>
													<Row style={{ marginLeft: '4px', marginTop: '12px' }}>
														<Col sm={6}>
															<InputGroup controlId='formBasicEmail'>
																<InputGroup.Text className='font-weight-bold'>
																	Member ID #
																	{/* <span style={{ color: "red" }}>*</span> */}
																</InputGroup.Text>

																<Form.Control
																	value={item?.id}
																	name='memberID'
																></Form.Control>
															</InputGroup>
														</Col>

														{/*  Security Clearance*/}
														<Col sm={6}>
															<InputGroup controlId='formBasicEmail'>
																<InputGroup.Text className='font-weight-bold'>
																	Professional Title
																</InputGroup.Text>

																<Form.Control
																	name='Professional_Title'
																	value={item?.professional_title?.name}
																/>
															</InputGroup>
														</Col>
													</Row>
													<Col
														sm={6}
														style={{ marginTop: '18px', marginLeft: '15px' }}
													>
														<InputGroup controlId='formBasicEmail'>
															<InputGroup.Text className='font-weight-bold'>
																Years Experience
																{/* <span style={{ color: "red" }}>*</span> */}
															</InputGroup.Text>

															<Form.Control
																value={item?.year_experience}
																name='max_applicants'
																rows='1'
															/>
														</InputGroup>
													</Col>

													{/* Select General & Specific Expertise */}
													<Row
														className='bg-label mt-4'
														style={{
															width: '98.2%',
															marginLeft: '16px',
															borderLeft: '1px solid',
															borderBottom: ' 1px solid',
															borderTop: ' 1px solid',
														}}
													>
														<Col
															sm={12}
															className='font-weight-bold p-1 ml-3 rounded fw-bold'
														>
															{' '}
															Select General & Specific Expertise
														</Col>
													</Row>

													{tagsFormatedData?.map((tag, index) => {
														return (
															<Row
																key={index}
																style={{
																	borderLeft: '1px solid',
																	borderBottom: ' 1px solid',
																	width: '98.1%',
																	marginLeft: '16px',
																}}
															>
																{/*  */}
																<Row
																	style={{
																		marginTop: '15px',
																		marginBottom: '15px',
																	}}
																>
																	<Col md={4}>
																		<InputGroup
																			controlId='formBasicEmail'
																			style={{ marginLeft: '12px' }}
																		>
																			<InputGroup.Text className='font-weight-bold'>
																				{index === 0
																					? 'Primary General '
																					: 'Secondary General'}
																			</InputGroup.Text>

																			{/*  Parent  */}
																			<Form.Control value={tag.parent.name} />
																		</InputGroup>
																	</Col>
																	{/* 1st child */}

																	{tag.child.map((child, index) => {
																		return (
																			<Col key={index} md={4}>
																				<InputGroup controlId='formBasicEmail'>
																					<InputGroup.Text className='font-weight-bold'>
																						Specific Field {index + 1}
																					</InputGroup.Text>

																					<Form.Control value={child.name} />
																				</InputGroup>
																			</Col>
																		);
																	})}
																</Row>
															</Row>
														);
													})}

													{/* Specialized Professional Skills * */}

													<Row
														className='bg-label mt-4'
														style={{
															width: '98.2%',
															marginLeft: '16px',
															borderLeft: '1px solid',
															borderBottom: ' 1px solid',
															borderTop: ' 1px solid',
														}}
													>
														<Col
															sm={12}
															className='font-weight-bold p-1 ml-3 rounded fw-bold'
														>
															{' '}
															Specialized Professional Skills
														</Col>
													</Row>
													<Row
														style={{
															borderLeft: '1px solid',
															borderBottom: ' 1px solid',
															width: '98.2%',
															marginLeft: '16px',
														}}
													>
														<Col sm={12} className='mt-2'>
															<ul className='list-group list-group-flush'>
																<li className='list-group-item font-weight-bold'>
																	{item?.specific_expertise?.map((item, i) => {
																		return (
																			<Form.Group
																				key={i}
																				controlId='formBasicEmail'
																			>
																				<Form.Control
																					name='first_name'
																					value={item}
																					style={{marginBottom:'12px'}}
																				/>
																			</Form.Group>
																		);
																	})}
																</li>
															</ul>
														</Col>
													</Row>
													{/* Tool Required/Recommended */}
													<Row
														className='bg-label mt-4'
														style={{
															width: '98.2%',
															marginLeft: '16px',
															borderLeft: '1px solid',
															borderBottom: ' 1px solid',
															borderTop: ' 1px solid',
														}}
													>
														<Col
															sm={12}
															className='font-weight-bold p-1 ml-3 rounded fw-bold'
														>
															{' '}
															Tool Required/Recommended
														</Col>
													</Row>
													<Row
														style={{
															borderLeft: '1px solid',
															borderBottom: ' 1px solid',
															width: '98.2%',
															marginLeft: '16px',
															marginBottom: '12px',
														}}
													>
														<Col sm={12} className='mt-2'>
															<ul className='list-group list-group-flush'>
																<li className='list-group-item font-weight-bold'>
																	{item?.tool?.map((item, i) => {
																		return (
																			<Form.Group
																				key={i}
																				controlId='formBasicEmail'
																			>
																				<Form.Control value={item} style={{marginBottom:'12px'}} />
																			</Form.Group>
																		);
																	})}
																</li>
															</ul>
															{/* <Row> */}
															{item?.must_own_tools?.map((item, i) => {
																return (
																	<Col
																		key={i}
																		sm={5}
																		style={{
																			marginBottom: '12px',
																			marginLeft: '33px',
																		}}
																	>
																		<Row style={{ marginTop: '15px' }}>
																			<InputGroup controlId='formBasicEmail'>
																				<InputGroup.Text className='font-weight-bold'>
																					Must Own Tools
																				</InputGroup.Text>

																				<Form.Control value={item} />
																			</InputGroup>
																		</Row>
																	</Col>
																);
															})}
															{item?.client_provides_tools?.map((item, i) => {
																return (
																	<Col
																		key={i}
																		sm={5}
																		style={{
																			marginBottom: '12px',
																			marginLeft: '33px',
																		}}
																	>
																		<Row style={{ marginTop: '15px' }}>
																			<InputGroup controlId='formBasicEmail'>
																				<InputGroup.Text className='font-weight-bold'>
																					Client Provides Tools
																				</InputGroup.Text>

																				<Form.Control value={item} style={{marginBottom:'12px'}}/>
																			</InputGroup>
																		</Row>
																	</Col>
																);
															})}
															{/* </Row> */}
														</Col>
													</Row>
													{/* Additional Skills * */}
													<Row
														className='bg-label mt-4'
														style={{
															width: '98.2%',
															marginLeft: '16px',
															borderLeft: '1px solid',
															borderBottom: ' 1px solid',
															borderTop: ' 1px solid',
														}}
													>
														<Col
															sm={12}
															className='font-weight-bold p-1 ml-3 rounded fw-bold'
														>
															{' '}
															Additional Skills
														</Col>
													</Row>
													<Row
														style={{
															borderLeft: '1px solid',
															borderBottom: ' 1px solid',
															width: '98.2%',
															marginLeft: '16px',
														}}
													>
														<Col sm={12} className='mt-2'>
															<ul className='list-group list-group-flush'>
																<li className='list-group-item font-weight-bold'>
																	{item?.other_requirements?.map((item, i) => {
																		return (
																			<Form.Group
																				key={i}
																				controlId='formBasicEmail'
																			>
																				<Form.Control
																					name='first_name'
																					value={item}
																					style={{marginBottom:'12px'}}
																				/>
																			</Form.Group>
																		);
																	})}
																</li>
															</ul>
														</Col>
													</Row>
													<br />
												</Form>

												{/* <Row className='row'>
												<img
													className='profile-img'
													src={item?.profile_image ? item.profile_image : prof}
													alt='profile'
												/>
												<Col>
													<h6 className='name'> {item.fullname} </h6>
													<h6 className='name'>ID: {item.id} </h6>
													<p className='designation'>Engineer</p>
												</Col>
												<button
													className='btn-download-resume p-2'
													onClick={() => viewProfileHandler(item)}
												>
													View {item.fullname}'s Profile
												</button>
												<button
													className='btn-short-list'
													onClick={() =>
														props.shortlisted(item.id, item.pivot.job_id)
													}
												>
													Short-list
												</button>
												<button
													className='btn-decline'
													onClick={() =>
														declineApplicantHandler(item.id, item.pivot.job_id)
													}
												>
													Decline
												</button>
											</Row>
											<br />
											<h6>Member Profile Data</h6>
											<hr />
											<h6>Tools</h6>

											<Row className='row'>
												{item.tool.map((data1, index) => (
													<span className='span'>{data1} </span>
												))}
											</Row>
											<h6>Expertise</h6>
											<Row className='row'>
												{item.specific_expertise.map((data1, index) => (
													<span className='span'>{data1} </span>
												))}
											</Row>
											<h6>Other requirements</h6>
											<Row className='row'>
												{item.other_requirements.map((data1, index) => (
													<span className='span'>{data1} </span>
												))}
											</Row>

											<hr />
											<h6>Selected Job Data</h6>
											<hr />
											{item?.pivot?.applicant_tool?.length > 0 && (
												<div>
													<h6>Tools</h6>
													<Row className='row'>
														{item.pivot.applicant_tool.map((data1, index) => (
															<span className='span'>{data1} </span>
														))}
													</Row>
												</div>
											)}

											{item?.pivot?.applicant_specific_expertise?.length >
												0 && (
												<div>
													<h6>Expertise</h6>
													<Row className='row'>
														{item.pivot.applicant_specific_expertise.map(
															(data1, index) => (
																<span className='span'>{data1}</span>
															)
														)}
													</Row>
												</div>
											)}
											{item?.pivot?.applicant_other_requirements?.length >
												0 && (
												<div>
													<h6>Requirements</h6>
													<Row className='row'>
														{item.pivot.applicant_other_requirements.map(
															(data1, index) => (
																<span className='span'>{data1}</span>
															)
														)}
													</Row>
												</div>
											)} */}
												<Row></Row>
											</Card.Body>
										</Card>
									</Accordion.Body>
								</Accordion.Item>

								{/* <div style={{ display: 'flex' }}>
										<h6 style={{ marginRight: '5px' }}>ID: {item.id}</h6>
										<MdArrowDropDown
											style={{ fontSize: '30px', marginLeft: '90%' }}
										/>
										
									</div> */}

								{/* <Accordion.Collapse eventKey='0'></Accordion.Collapse> */}
							</Card>
						</Accordion>
					);
				})}
			</Row>
		</div>
	);
}

export default NewApplicants;
